import React, { useState, useEffect, useRef } from 'react';

function ChatAgent() {
    const [isOpen, setIsOpen] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (isOpen && !isInitialized && containerRef.current) {
            
            const frontdoorUrl = localStorage.getItem('frontdoor_url');
            const instanceUrl = localStorage.getItem('instance_url');

            if (!frontdoorUrl || !instanceUrl) {
                console.error('Salesforce credentials not found. Cannot initialize Analytics Agent.');
                if (containerRef.current) {
                    containerRef.current.innerHTML = '<p class="error-message">Authentication is required to use the agent.</p>';
                }
                return;
            }

            import('@salesforce/analytics-embedding-sdk')
                .then(async ({ initializeAnalyticsSdk, AnalyticsAgent, AgentContextType }) => {
                    // Initialize SDK first (like other components)
                    const config = {
                        authCredential: frontdoorUrl,
                        orgUrl: instanceUrl,
                    };
                    
                    try {
                        await initializeAnalyticsSdk(config);
                        
                        // Create the agent with context configuration
                        // Use AgentContextType enum from the SDK
                        const agent = new AnalyticsAgent({
                            parentIdOrElement: containerRef.current,
                            idOrApiName: "0XxMM0000000FBx0AM", // Replace by your agent id!
                            contextType: AgentContextType.DASHBOARD,
                            contextTypeIdOrApiName: "Sales_Cloud_Dashboard",
                            showHeader: true,
                            showHeaderActions: true
                        });
                        agent.render();
                        setIsInitialized(true);
                    } catch (error) {
                        console.error('Failed to initialize SDK or create agent:', error);
                        if (containerRef.current) {
                            containerRef.current.innerHTML = '<p class="error-message">Could not initialize Analytics Agent.</p>';
                        }
                    }
                })
                .catch(error => {
                    console.error('Failed to load Analytics Agent:', error);
                    if (containerRef.current) {
                        containerRef.current.innerHTML = '<p class="error-message">Could not load Analytics Agent.</p>';
                    }
                });
        }
    }, [isOpen, isInitialized]);

    const toggleChat = () => setIsOpen(!isOpen);

    return (
        <>
            <button 
                className="chat-button" 
                onClick={toggleChat} 
                title="Chat with Analytics Assistant"
            >
                <i className="fas fa-comments"></i>
                <div className="chat-pulse"></div>
            </button>

            <div className={`chat-overlay ${isOpen ? 'open' : ''}`}>
                <header className="chat-header">
                    <h3>Analytics Agent</h3>
                    <button 
                        className="chat-close-btn" 
                        onClick={toggleChat}
                        title="Close"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </header>
                <div className="chat-body" ref={containerRef}>
                </div>
            </div>
        </>
    );
}

export default ChatAgent;
